import { useState, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import { SiteManContext } from "../SiteManContext";

const EditSiteForm = ({ site = {}, handleClose }) => {
  const { updateSite } = useContext(SiteManContext);

  // Helper per formattare la data in modo sicuro
  const formatDateForInput = (rawDate) => {
    if (!rawDate) return "";
    if (typeof rawDate === "string" && rawDate.includes("/")) {
      const parts = rawDate.split("/");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
      }
    }
    try {
      const parsedDate = new Date(rawDate);
      return isNaN(parsedDate.getTime()) ? "" : parsedDate.toISOString().split("T")[0];
    } catch {
      return "";
    }
  };

  const [formData, setFormData] = useState({
    idpresenze: site?.idpresenze || "",
    nome: site?.nome || "",
    tipologia: site?.tipologia || "",
    comune: site?.comune || "",
    localita: site?.["localit�"] || site?.localita || "",
    stato_conservazione: site?.stato_di_conservazione || site?.stato_conservazione || "",
    compilatore: site?.compilatore || "",
    data: formatDateForInput(site?.data),
    visibilita: site?.["visibilit�"] || site?.visibilita || "",
    descrizione: site?.descrizione || "",
    note: site?.note || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const siteId = site?.geom_id ?? site?.objectid_1 ?? site?.objectid;
    if (siteId) {
      await updateSite(siteId, formData);
    }
    handleClose();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-2">
        <Form.Label>ID Presenze</Form.Label>
        <Form.Control type="text" name="idpresenze" value={formData.idpresenze} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Nome</Form.Label>
        <Form.Control type="text" name="nome" value={formData.nome} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Tipologia</Form.Label>
        <Form.Control type="text" name="tipologia" value={formData.tipologia} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Comune</Form.Label>
        <Form.Control type="text" name="comune" value={formData.comune} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Localit�</Form.Label>
        <Form.Control type="text" name="localita" value={formData.localita} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Stato Conservazione</Form.Label>
        <Form.Control type="text" name="stato_conservazione" value={formData.stato_conservazione} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Compilatore</Form.Label>
        <Form.Control type="text" name="compilatore" value={formData.compilatore} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Data</Form.Label>
        <Form.Control type="date" name="data" value={formData.data} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Visibilit�</Form.Label>
        <Form.Control type="text" name="visibilita" value={formData.visibilita} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Descrizione</Form.Label>
        <Form.Control as="textarea" rows={3} name="descrizione" value={formData.descrizione} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Note</Form.Label>
        <Form.Control as="textarea" rows={2} name="note" value={formData.note} onChange={handleChange} />
      </Form.Group>

      <Button variant="warning" type="submit" className="mt-3 w-100">
        Aggiorna Sito
      </Button>
    </Form>
  );
};

export default EditSiteForm;